import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  ListItemText,
  Modal,
  Typography,
  Tooltip,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { cancelTrip, getCancelCharges } from "redux/actions/OperationsAction";
import { getCancelReason, getReservationDetails } from "redux/actions/reservationAction";
import { getDateFormat, getTimeFormat, truncateComment } from "utils/utils";
import CommonButton from "components/commonButton/CommonButton";

const CancelRegistrationModal = ({ open, toggle, reservationData, page ,payload}) => {
  const dispatch = useDispatch();
  const [checkBoxSelect, setCheckboxSelect] = useState(false);
  const [cancelCharges, setCancelCharges] = useState(false);
  const [cancelReason, setCancelReason] = useState('');
  const cancelReasonList = useSelector((state) => state.getCancelReason?.cancelReason?.data);
  useEffect(() => {
    if (reservationData?.id) {
      if (page === "allRides") {
        dispatch(getReservationDetails(reservationData?.id));
      }
    }
  }, [open]);

  useEffect(() => {
    dispatch(getCancelReason())
  }, [])

  const reservationDetails = useSelector(
    (state) => state.getReservationDetails?.reservationDetails?.data
  );
  const chargesResponse = useSelector(
    (state) => state?.cancelationTripCharges?.cancelCharges?.data
  );

  const mappingData = reservationDetails || reservationData;

  const handleClose = () => {
    setCancelCharges(false);
    setCheckboxSelect(false);
    toggle();
  };

  const handleModal = () => {
    dispatch(getCancelCharges(reservationData?.id, setCancelCharges));
  };

  const handleCancelTrip = () => {
    const data={
      id:reservationData?.id,
      reason:cancelReason
    }
    dispatch(cancelTrip(data, page,payload));
    handleClose();
  };

  const handleChange = (e) => {
    setCancelReason(e.target.value)
  }

  const scheduledTime = new Date(mappingData?.scheduledTime);
const currentTime = new Date();
// Comparing two dates and converting into hours format (36e5 is definition of 60*60*1000)
let hrFormat = (scheduledTime.getTime() - currentTime.getTime()) / 36e5;
const totalMinutes = Math.max(hrFormat * 60, 0);  // Convert hours to minutes
const hours = Math.floor(totalMinutes / 60);
const minutes = Math.floor(totalMinutes % 60);
const timeLeft = `${hours > 0 ? hours + ' hr ' : ''}${minutes > 0 ? minutes + ' min' : ''}`;

  return (
    <>
      <Modal
        open={open || false}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="customModal"
      >
        {!cancelCharges ? (
          <Box
            className="modalContent cancelModalDetails textLeft"
            sx={{ height: { xs: "100%", sm: "auto" } }}
          >
            <Box className="justifyEnd">
              <CloseIcon onClick={handleClose} />
            </Box>
            <Box className="justifyBetween">
              <Box className="alignStart">
                <Typography variant={"head3"} className="colorPrimary fw600">
                  Cancel
                  <span className="colorYellow"> Reservation</span>
                </Typography>
                <Typography variant={"head5"} className="colorBlack fw600 pl20">
                  Booking ID - {mappingData?.tripId}
                </Typography>
              </Box>
            </Box>
            <Box className="mb20">
              <ListItemText
                primary={
                  <Typography variant={"body1"} className="colorGrey">
                    Company Name -
                  </Typography>
                }
                secondary={
                  <Typography variant={"body1"} className="colorBlack">
                    &nbsp;{mappingData?.companyName}
                  </Typography>
                }
                className="alignStart pt20 m0"
              />
              <ListItemText
                primary={
                  <Typography variant={"body1"} className="colorGrey">
                    Passenger Name -
                  </Typography>
                }
                secondary={
                  <Typography variant={"body1"} className="colorBlack">
                    &nbsp;{mappingData?.customerName}
                  </Typography>
                }
                className="alignStart pt20 m0"
              />
              <ListItemText
                primary={
                  <Typography variant={"body1"} className="colorGrey">
                    Report Address -
                  </Typography>
                }
                secondary={
                  <Tooltip title={mappingData?.sourceAddress || mappingData?.sourceLandMarkAddress} arrow>
                    <Typography variant={"body1"} className="colorBlack">
                      &nbsp; {truncateComment(mappingData?.sourceAddress || mappingData?.sourceLandMarkAddress, 80)}
                    </Typography>
                  </Tooltip>
                }
                className="alignStart pt20 m0"
              />
              <ListItemText
                primary={
                  <Typography variant={"body1"} className="colorGrey">
                    Reporting Date -
                  </Typography>
                }
                secondary={
                  <Typography variant={"body1"} className="colorBlack">
                    &nbsp;
                    {getDateFormat(mappingData?.scheduledTime)}
                  </Typography>
                }
                className="alignStart pt20 m0"
              />
              <ListItemText
                primary={
                  <Typography variant={"body1"} className="colorGrey">
                    Report Time -
                  </Typography>
                }
                secondary={
                  <Typography variant={"body1"} className="colorBlack">
                    &nbsp;
                    {getTimeFormat(mappingData?.scheduledTime)}
                  </Typography>
                }
                className="alignStart pt20 m0"
              />
              <Box className="alignStart  pt20">
                <Typography variant={"body1"} className="colorBlack">
                  Reason of cancellation -&nbsp;
                </Typography>
                <Box className='width60'>
                  <FormControl fullWidth className="commonFormControl">
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        onChange={handleChange}
                        placeholder="Select"
                        displayEmpty
                      >
                        <InputLabel className="colorGrey ml16">
                          <Typography
                            className="colorGrey"
                            variant="body2"
                          >
                            Select Reason
                          </Typography>
                        </InputLabel>
                        {cancelReasonList?.map((item, index) => (
                          <MenuItem value={item?.reason} key={index}>
                            {item?.reason}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                </Box>
              </Box>
            </Box>
            <CommonButton
              name="Cancel Reservation"
              btnClass={"btnLarge"}
              onClick={handleModal}
              disabled={cancelReason ? false : true}
            />
          </Box>
        ) : (
          <Box
            className="modalContent cancelModalCharges textLeft"
            sx={{ height: { xs: "100%", sm: "auto" } }}
          >
            <Box className="justifyEnd">
              <CloseIcon onClick={handleClose} />
            </Box>
            <Box className="justifyBetween">
              <Box className="alignStart">
                <Typography variant={"head3"} className="colorPrimary fw600">
                  Cancel
                  <span className="colorYellow"> Reservation</span>
                </Typography>
                <Typography variant={"head5"} className="colorBlack fw600 pl20">
                  Booking ID - {mappingData?.tripId}
                </Typography>
              </Box>
            </Box>
            <Box>
              <Typography variant={"body2"} className="ptb10">
                We appreciate your feedback on this cancellation.
              </Typography>
              <Grid container>
                <Grid
                  container
                  justifyContent={"space-between"}
                  className="mt10 dashedBorderBottom pb10"
                >
                  <Grid
                    item
                    xs={6}
                    container
                    alignItems={"flex-start"}
                    flexDirection={"column"}
                  >
                    <Typography variant={"body1"} className="colorBlack mb10">
                    Total fare
                    </Typography>
                    <Typography variant={"body1"} className="colorBlack">
                      Cancellation Fee
                    </Typography>
                    <Typography
                      variant={"body4"}
                      className="textRight colorGrey"
                    >
                      You are cancelling the ride before {timeLeft}
                    </Typography>
                  </Grid>
                  <Grid item container xs={6} justifyContent={"flex-end"}>
                    <Grid item xs={6} flex justifyContent={"center"}>
                      <Typography
                        variant={"body1"}
                        className="textLeft colorBlack mb10"
                      >
                        ₹ {chargesResponse?.totalCharges}
                      </Typography>
                      <Typography
                        variant={"body1"}
                        className="textLeft colorBlack"
                      >
                        ₹ {chargesResponse?.cancellationCharges}
                      </Typography>
                    </Grid>
                
                  </Grid>
                </Grid>
              </Grid>
              <Typography variant={"body1"} className="colorBlack">
                Are you sure you want to cancel?
              </Typography>
              <Typography
                variant={"body3"}
                className="textRight colorGrey"
                component={"p"}
              >
                This trip has been offered to a driver right now, and should be
                confirmed within seconds.
              </Typography>

              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkBoxSelect}
                    onChange={(event) =>
                      setCheckboxSelect(event.target.checked)
                    }
                  />
                }
                label={<Typography component="p" variant="body3">I have read and agree to the <Typography className="colorPrimary" variant="body3" component={"span"}>cancellation policy.</Typography></Typography> }
              />
              <CommonButton
                name="Cancel Reservation"
                btnClass={"btnLarge"}
                disabled={!checkBoxSelect}
                onClick={handleCancelTrip}
              />
            </Box>
          </Box>
        )}
      </Modal>
    </>
  );
};

export default CancelRegistrationModal;
